import { render, staticRenderFns } from "./hdyy.vue?vue&type=template&id=49d3c2c7&scoped=true&"
import script from "./hdyy.vue?vue&type=script&lang=js&"
export * from "./hdyy.vue?vue&type=script&lang=js&"
import style0 from "./hdyy.vue?vue&type=style&index=0&id=49d3c2c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3c2c7",
  null
  
)

export default component.exports